export const NarrativeMiniValuatorValuationSkeleton = () => {
  return (
    <section
      className="grid gap-x1"
      role="presentation"
      aria-label="Loading skeleton"
    >
      <div className="bones h-x4 py-x1" />
    </section>
  );
};
